import React, { useEffect } from "react";

import { Box, Button } from "@mui/material";

const Header = ({ title, back = null, button = null, onclick }) => {
  const [backShow, setBackShow] = React.useState(back != null ? back : false);
  useEffect(() => {
    if (window.location.pathname == "/dashboard") {
      return setBackShow(back != null ? back : false);
    }

    if (window.location.pathname != "/") {
      return setBackShow(back != null ? back : true);
    }

    return () => {
      setBackShow(false);
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        alignContent: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        padding: "15px 5px",
      }}
      container
      alignContent={"end"}
      justifyContent={"space-between"}
    >
      {/* back icon */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          alignContent: "center",
          flexDirection: "row",
        }}
      >
        {backShow && (
          <Box
            sx={{ marginRight: 3, cursor: "pointer" }}
            onClick={() => {
              window.history.back();
            }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/507/507257.png"
              style={{
                width: 25,
                height: 25,
                // tint image color to white from balck
                filter: "invert(100%)",
              }}
            />
          </Box>
        )}

        <Box>
          <h2>{title}</h2>
        </Box>
      </Box>
      {button != null && (
        <Box>

          <div
            className="btn "
            style={{ backgroundColor: " #FFC857", color: "black", fontWeight:"700",cursor: "default",   }}



            onClick={() => {
              onclick && onclick();
            }}
            // className="m-1 btn-primary"
          >
          + {button}
          </div>
        </Box>
      )}
    </Box>
  );
};

export default Header;
